import chroma from 'chroma-js';

export const generateSimilarColorShades = (baseColor: string, numShades: number) => {
  const colorScale = chroma.scale([baseColor, '#05b6b2']).colors(numShades);
  return colorScale;
};
